import React from 'react';
import SideMenuGroup from '../side_menu_group/side_menu_group';
import SideMenuItem from '../side_menu_item/side_menu_item';
export var appearances = ['outlined', 'dropShadow'];
export var deprecatedAppearances = ['small', 'large'];
export function deprecatedAppearanceValidator(validator) {
  return function (props, propName, componentName) {
    var value = props[propName];
    var hasDeprecatedApparance = deprecatedAppearances.indexOf(value) !== -1;
    if (process.env.NODE_ENV !== 'production' && hasDeprecatedApparance) {
      console.warn(["@veneer/core: The value `".concat(value, "` supplied to `").concat(componentName, ".").concat(propName, "` was deprecated."), "Use the prop `size` instead."].join('\n'));
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return validator(props, propName, componentName, ...rest);
  };
}
export function sideMenuGroupValidator(validator) {
  return function (props, propName, componentName) {
    var children = props[propName];
    var hasSpecificChild = () => Array.isArray(children) && children.length > 1 && children.some(child => /*#__PURE__*/React.isValidElement(child) && (child.type === SideMenuGroup || child.type === SideMenuItem));
    if (hasSpecificChild()) {
      console.warn('@veneer/core: SideMenuGroup and SideMenuItem cannot co-exist at the same level.');
    }
    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }
    return validator(props, propName, componentName, ...rest);
  };
}